// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__31JBu","question":"Question_question__2bvaX","description":"Question_description__TwoSu"};